<script>
import {mapGetters} from 'vuex'

export default {

    name: 'create-quiz-creative',

    props:
    {
        quiz:Object,
    },

    computed:
    {
        ...mapGetters({
            dirty: 'offerFormIsDirty'
        }),
    },

    data()
    {
        return {
            customToolbar: [
                ['bold', 'italic', 'underline'],
                [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                ['image', 'code-block']
            ],
            tempQuiz: {
                colors: [
                    {
                        color: '#cccccc'
                    }
                ],
                styles: [
                    {
                        name: 'Solid buttons',
                        id: 1
                    }
                ],
                headlines: [
                    {
                        text: 'BÉLAAA',
                        id: 1
                    }
                ],
                bodies: [
                    {
                        text: 'BÉLAAA',
                        id: 1
                    }
                ],
                desktop_images: [],
                mobile_images: [],
            },
            styles:[
                {
                    name: 'Solid buttons',
                    id: 1
                },
                {
                    name: 'Egyéb buttons',
                    id: 2
                }
            ],
            isFacebook: false,
            isGoogle: false,
            isEmail: false,
        }
    },

    watch: {
        '$route': 'setData'
    },

    methods: {
        setData()
        {

        },

        preview(){
            this.$store.dispatch('quizUpdate', this.offer).then(res => {
                window.location.href = `${process.env.FRONTEND_URL}/preview/${this.quiz.url}`
            })
        },

        addDesktopImage(file)
        {
            this.tempQuiz.desktop_images.length = 0
            this.tempQuiz.desktop_images.push(file)
        },
        addMobileImage(file)
        {
            this.tempQuiz.mobile_images.length = 0
            this.tempQuiz.mobile_images.push(file)
        },

        save()
        {
            if (this.dirty) {
                this.$refs.confirmModal.openModal()
            } else {
                this.$store.dispatch('quizUpdate', this.quiz).then(res=>{
                    this.$emit('saved')
                })
            }
        },
        discard()
        {
            // this.$router.push({ name: 'quiz-subpages', params: {slug: 'live', page: 1, order: 'asc', sort: 'offer_id'}})
        },

        setDirty()
        {
            this.$store.dispatch('quizFormDirty', true)
        },

        setClean()
        {
            this.$store.dispatch('quizFormDirty', false)
        },
    },

    mounted()
    {
        this.setData()
    },
}
</script>

<template lang="html">
    <div class="quiz-creative">
        <confirm-modal @yes="save" ref="confirmModal"></confirm-modal>
        <div class="container quiz-field-block">
            <div class="row">
                <div class="col-3">
                    <div class="pl-3 left-grey-border-2">
                        <h5 class="font-weight-semibold">
                            Key Visual
                        </h5>
                    </div>
                    <div class="pl-3 pr-4">
                        <p class="text-desc2-color">
                            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                        </p>
                    </div>
                </div>
                <div class="col-9">
                    <div class="container pt-3">
                        <div class="row">
                            <div class="col-2 text-right pt-1 font-weight-bold">
                                Style
                            </div>
                            <div class="col-7">
                                <custom-multiselect
                                @selected="tempQuiz.styles[0] = $event"
                                :selectedValue="tempQuiz.styles[0]"
                                labelClasses="font-weight-bold text-right pr-3"
                                class="mb-3"
                                :options="styles"
                                modelLabel="name"
                                ></custom-multiselect>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-2 text-right pt-1 font-weight-bold">
                                Primary Color
                            </div>
                            <div class="col-10">
                                <div class="row">
                                    <div class="col-12 mb-2">
                                        <div class="row">
                                            <div class="col-5">
                                                <color-picker v-model="tempQuiz.colors[0].color"></color-picker>
                                            </div>
                                            <div class="col-7">
                                                <div class="btn btn-color-preview" :style="{ backgroundColor: tempQuiz.colors[0].color }">
                                                    <i class="fa fa-eye"></i>
                                                    Can you read it ?
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-7">
                                        <p>
                                            Primary color is used for headline, and sticker background.
                                            Pick a color that gives good contrast.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container quiz-field-block">
            <div class="row">
                <div class="col-3">
                    <div class="pl-3 left-grey-border-2">
                        <h5 class="font-weight-semibold">
                            Landing Page
                        </h5>
                    </div>
                    <div class="pl-3 pr-4">
                        <p class="text-desc2-color">
                            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                        </p>
                    </div>
                </div>
                <div class="col-9">
                    <div class="container pt-3">
                        <div class="row mb-1">
                            <div class="col-2 text-right pt-1 font-weight-bold">
                                Headline
                            </div>
                            <div class="col-10">
                                <simple-input
                                type="text"
                                v-model="tempQuiz.headlines[0].text"
                                placeholder="Type a headline"
                                noRadius
                                ></simple-input>
                            </div>
                        </div>
                        <div class="row mb-4">
                            <div class="col-2"></div>
                            <div class="col-10 text-desc-color text-sm">
                                <span v-if="tempQuiz.headlines[0].text">
                                    {{ 70-tempQuiz.headlines[0].text.length }} characters left
                                </span>
                            </div>
                        </div>
                        <div class="row mb-4">
                            <div class="col-2 text-right pt-1 font-weight-bold">
                                Lead
                            </div>
                            <div class="col-10">
                                <text-editor :customToolbar="customToolbar" v-model="tempQuiz.bodies[0].text"></text-editor>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-2 text-right pt-1">
                                <strong>Desktop image</strong>
                                 <br>
                                 <i class="fas fa-info-circle"></i>
                                 <span class="text-sm">720×400 px</span>
                            </div>
                            <div :class="{'mx-auto mt-2': tempQuiz.desktop_images && tempQuiz.desktop_images.length == 0}">
                                <template v-if="tempQuiz.desktop_images && tempQuiz.desktop_images.length == 0">
                                    <image-uploader
                                        type="desktop"
                                        ref="uploader"
                                        @upload-done="addDesktopImage($event)"
                                        accept="image/*"
                                        @dirty="setDirty"
                                        @clean="setClean"
                                        :width="720"
                                        :height="400"></image-uploader>
                                </template>
                                <template v-else>
                                    <img class="uploaded-image" v-for="image in tempQuiz.desktop_images" :key="image.id" :src="image.display_url">
                                    <custom-button classes="white text-desc-color xs" iconBeforeText="far fa-trash" @buttonClick="tempQuiz.desktop_images = []"></custom-button>
                                </template>
                            </div>
                        </div>
                        <div class="row ">
                            <div class="col-2 text-right pt-1">
                                <strong>Mobile image</strong>
                                 <br>
                                 <i class="fas fa-info-circle"></i>
                                 <span class="text-sm">670x480 px</span>
                            </div>
                            <div :class="{'mx-auto mt-2': tempQuiz.mobile_images && tempQuiz.mobile_images.length == 0}">
                                <template v-if="tempQuiz.mobile_images && tempQuiz.mobile_images.length == 0">
                                    <image-uploader
                                        type="mobile"
                                        ref="uploader"
                                        @upload-done="addMobileImage($event)"
                                        accept="image/*"
                                        @dirty="setDirty"
                                        @clean="setClean"
                                        :width="670"
                                        :height="480"
                                        ></image-uploader>
                                </template>
                                <template v-else>
                                    <img class="uploaded-image" v-for="image in tempQuiz.mobile_images" :key="image.id" :src="image.display_url">
                                    <custom-button classes="white text-desc-color xs" iconBeforeText="far fa-trash" @buttonClick="tempQuiz.mobile_images = []"></custom-button>
                                </template>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="container quiz-field-block">
            <div class="row mb-5">
                <div class="col-3">
                    <div class="pl-3 left-grey-border-2">
                        <h5 class="font-weight-semibold">
                            How to start
                        </h5>
                    </div>
                    <div class="pl-3 pr-4">
                        <p class="text-desc2-color">
                            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                        </p>
                    </div>
                </div>
                <div class="col-9">
                    <div class="container">
                        <div class="row mb-3">
                            <div class="col-2"></div>
                            <div class="col-10 font-weight-bold">
                                Select option(s)
                            </div>
                        </div>
                    </div>
                    <custom-selectable-box
                    type="checkbox"
                    v-model="isFacebook"
                    colLeft="2"
                    colRight="10"
                    icon="fab fa-facebook"
                    label="Start with Facebook"
                    ></custom-selectable-box>
                    <custom-selectable-box
                    type="checkbox"
                    v-model="isGoogle"
                    colLeft="2"
                    colRight="10"
                    icon="fab fa-google"
                    label="Start with Google"
                    ></custom-selectable-box>
                    <custom-selectable-box
                    type="checkbox"
                    v-model="isEmail"
                    colLeft="2"
                    colRight="10"
                    icon="fas fa-envelope"
                    label="Start with Email"
                    ></custom-selectable-box>
                </div>
            </div>
        </div>
        <div class="grey-bg border-bottom-1-secondary border-sides-1-secondary px-3 py-2">
            <div class="row">
                <div class="col-3">
                    <custom-button classes="white text-desc-color xs" iconBeforeText="fas fa-eye mr-2" text="Preview" @buttonClick="preview"></custom-button>
                </div>
                <div class="col-9 text-right">
                    <custom-button classes="white text-uppercase text-desc-color w-120" text="Discard" @buttonClick="discard"></custom-button>
                    <custom-button classes="purple text-uppercase text-white w-120" text="Save" @buttonClick="save"></custom-button>
                </div>
            </div>
        </div>
    </div>

</template>



// WEBPACK FOOTER //
// src/pages/tools/quizzes/edit/Creative.vue